import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/ui/DropdownMenu';

import OrganizationDepartmentsIcon from '@assets/icons/organization-departments.svg?react';

import { organizationItems } from './DesktopSidebar.config';
import {
  activeNavItemStyle,
  dropdownContentClass,
} from './DesktopSidebar.styles';
import {
  getNavItemClass,
  SidebarAccordion,
  SidebarItemContent,
  SidebarLink,
} from './DesktopSidebarNav';
import type { SidebarGroup } from './DesktopSidebar.types';

type DesktopSidebarOrganizationProps = {
  groups: SidebarGroup[];
  groupsLoading: boolean;
  accordionOpen: boolean;
  otdelsOpen: boolean;
  selectedGroupId: string | null;
  selectedGroupName: string;
  onNavigate: (to: string) => void;
  onAccordionToggle: () => void;
  onOtdelsOpenChange: (open: boolean) => void;
};

export function DesktopSidebarOrganization({
  groups,
  groupsLoading,
  accordionOpen,
  otdelsOpen,
  selectedGroupId,
  selectedGroupName,
  onNavigate,
  onAccordionToggle,
  onOtdelsOpenChange,
}: DesktopSidebarOrganizationProps) {
  return (
    <SidebarAccordion
      title="КОМПАНИЯ"
      open={accordionOpen}
      onToggle={onAccordionToggle}
    >
      <SidebarLink item={organizationItems[0]} />

      <DropdownMenu open={otdelsOpen} onOpenChange={onOtdelsOpenChange}>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            className={getNavItemClass(Boolean(selectedGroupId))}
            style={selectedGroupId ? activeNavItemStyle : undefined}
          >
            <SidebarItemContent
              Icon={OrganizationDepartmentsIcon}
              label={selectedGroupName}
              active={Boolean(selectedGroupId)}
            />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          side="bottom"
          align="start"
          className={dropdownContentClass}
        >
          {groupsLoading ? (
            <DropdownMenuItem disabled>Загрузка...</DropdownMenuItem>
          ) : (
            groups
              .slice()
              .sort((a, b) => a.Name.localeCompare(b.Name, 'ru'))
              .map((group) => (
                <DropdownMenuItem
                  key={group.ID}
                  className={
                    String(group.ID) === selectedGroupId
                      ? 'cursor-pointer text-[calc(13px*var(--nav-scale,1))] bg-[#102653] text-white focus:bg-[#102653] focus:text-white'
                      : 'cursor-pointer text-[calc(13px*var(--nav-scale,1))] focus:bg-[#F6F7FA] focus:text-[#17244A]'
                  }
                  onSelect={() => onNavigate(`/groups/${group.ID}`)}
                >
                  {group.Name}
                </DropdownMenuItem>
              ))
          )}
        </DropdownMenuContent>
      </DropdownMenu>

      <SidebarLink item={organizationItems[1]} />
    </SidebarAccordion>
  );
}
